import { FormQuestionType } from '@fi-shared/fi-form-shared/fi-form-enums';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IFormQuestionViewData } from '@fi-app/fi-form/fi-form';
import { CdkDropList } from '@angular/cdk/drag-drop';

@Component({
    selector: 'fi-form-elements',
    template: ` <div
        class="elements-wrapper"
        cdkDropList
        cdkDropListSortingDisabled
        cdkDropListHasAnchor
        [cdkDropListData]="elements"
        [cdkDropListConnectedTo]="[questionsDropList]"
    >
        <p class="elements-wrapper-head-text">
            {{ 'form_elements.form_elements' | fiAppText }}
            <fi-info-icon>{{ 'form_elements.tooltip_text' | fiAppText }}</fi-info-icon>
        </p>
        @for (element of elements; track element.type) {
            <mat-card class="form-element-card" (click)="onClick(element)" cdkDrag>
                <mat-icon class="BrandedColor {{ element.icon }}" />
                <span>{{ element.name | fiAppText }}</span>
            </mat-card>
        }
    </div>`,
    styleUrls: ['./fi-form-elements.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-form-elements' },
    standalone: false,
})
export class FiFormElementsComponent {
    @Input() questionsDropList: CdkDropList;
    @Output() formElementClick = new EventEmitter<IFormQuestionViewData>();

    elements: IFormQuestionViewData[] = [
        {
            name: 'form.answer_text',
            type: FormQuestionType.Text,
            icon: 'fas fa-keyboard',
        },
        {
            name: 'form.answer_numeric',
            type: FormQuestionType.Numeric,
            icon: 'fas fa-calculator',
        },
        {
            name: 'forms.answer_single_choice',
            type: FormQuestionType.SingleChoice,
            icon: 'fas fa-check',
        },
        {
            name: 'forms.answer_multiple_choice',
            type: FormQuestionType.MultipleChoice,
            icon: 'fas fa-list-ul',
        },
        {
            name: 'form.heading',
            type: FormQuestionType.Heading,
            icon: 'fas fa-heading',
        },
        {
            name: 'forms.text_message',
            type: FormQuestionType.TextMessage,
            icon: 'fas fa-align-left',
        },
        {
            name: 'templateItem.media.name',
            type: FormQuestionType.MediaBank,
            icon: 'fas fa-photo-video',
        },
        {
            name: 'form.file_attachment',
            type: FormQuestionType.Attachment,
            icon: 'fas fa-file-upload',
        },
    ];

    onClick(element: IFormQuestionViewData) {
        this.formElementClick.next(element);
    }
}
